import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["created_date"],
            "sorts": ["asc"]
        },
        "filters": [],
        "pageNo":1,
        "itemsPerPage": 8
    },
    yearfilter:{
        "listType":"magazine_year",
        "replacements":["%%"]
    }
};

const magazineSlice = createSlice({
    name: 'magazine',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
} = magazineSlice.actions;

export default magazineSlice.reducer;
